
<div>
    <v-row v-if="textSearch" class="no-frame lm-border pa-3 mb-2 mt-0 pt-0">
        <v-col class="no-frame">
            <v-text-field
                v-model="filter.text"
                hide-details
                @input="onSearchText"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame mr-1 lm-border pa-3 pt-1 pb-1">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "Liftmanagement"
                        v-model = "filter.lim"
                        class   = "mt-0 pr-2"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                        style="width: 150px;"
                    />
                    <c-tag
                        class="mt-2"
                        label="LIM"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   ="DLS"
                        v-model = "filter.dls"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        style="width: 150px;"
                        hide-details
                    />
                    <c-tag
                        class="mt-2"
                        label="DLS"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame" v-if="showMisc">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "Projekt"
                        v-model = "filter.misc"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        style   = "width: 150px;"
                        hide-details
                    />
                    <c-tag
                        class="mt-2"
                        label=""
                    />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="no-frame lm-border pa-3 pt-1 pb-2 ml-1">
            <v-row class="no-frame" >
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "Meine Kunden"
                        v-model = "myCustomers"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onCustomerChanged"
                        hide-details
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "aktiv"
                        v-model = "filter.active"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "inaktiv"
                        v-model = "filter.inactive"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</div>
